<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_79')"
    icon="res-billtag"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :getParams="getParams"
      :hiddenKindTabs="hiddenKindTabs"
      :defaultTag="defaultTag"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillTagSidePage',
  components: {
    Actions,
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isDomainMode', 'scope']),
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillTagSidePage'
        default:
          return ''
      }
    },
    getParams () {
      return {}
    },
    hiddenKindTabs () {
      if (this.isDomainMode) {
        return ['domain', 'tag', 'external_project']
      } else if (this.isProjectMode) {
        return ['domain', 'project', 'tag', 'external_project']
      }
      return ['tag', 'external_project']
    },
    defaultTag () {
      return {
        key: this.detailData.key,
        value: this.detailData.value || '',
      }
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || ''
      return { dateParam, dateMode }
    },
  },
}
</script>
